import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthImaage from "../../assets/images/authbanner.png";
import { API_ROUTES } from "@/services/environment";
import { POST } from "@/services/api";
import Alert from "@/components/alert/Alert";
import { AuthModal } from "@thdinc/hpf-shared";

const CheckEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sendAgain, setSendAgain] = useState<boolean>(false);
  const [timeLeft, setTimeLeft] = useState(60);
  const { forgotPassword } = API_ROUTES;
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const email = location?.state?.email;

  // update the timer state
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (timeLeft > 0) {
        setTimeLeft(timeLeft - 1);
      } else {
        clearInterval(intervalId);
      }
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  useEffect(() => {
    if (!email) {
      navigate("/login");
    }
    setTimeout(() => {
      setSendAgain(true);
    }, 60000);
  }, []);
  const sendAgainFun = async () => {
    // send verify link again 
    try {
      setSendAgain(false);
      setTimeLeft(60);
      const res = await POST(forgotPassword, { email });
      if (res?.status === 200) {
        Alert({ message: "Email sent" });
      } else {
        Alert({ message: "Something went wrong", type: "error" });
      }
    } catch (error) {
      console.log(error);
      Alert({ message: "Something went wrong", type: "error" });
    } finally {
      setTimeout(() => {
        setSendAgain(true);
      }, 60000);
    }
  };

  return (
    <div className="container mx-auto h-screen relative">
      <div className="flex flex-col justify-center  min-h-full ">
        <div className="flex justify-center">
          <img
            className="w-[500px] hidden lg:block rounded-3xl"
            src={AuthImaage}
            alt=""
          />
          <div className="flex flex-col justify-center lg:-ml-11 ">
            <AuthModal>
              <div className="text-center">
                <p className="text-2xl font-bold ">Check Your Email</p>
                <p className=" mt-6 text-start ">
                  {` We've sent a verification link to reset your password at  ${email}. if you're unable to see the link within inbox, please check your junk and spam emails too. `}
                  <Link className="mx-auto text-primary-red ml-1" to="/forget/password">
                    Not your email?
                  </Link>
                </p>
              </div>

              <div className="text-center ">

                <div></div>
                <p className="text-start mt-3">
                  {`If you didn't receive the verification link, click`}
                  <button
                    disabled={!sendAgain}
                    onClick={sendAgainFun}
                    className={`${sendAgain ? " text-primary-red underline" : "text-red-200"
                      } px-1 `}
                  >
                    here
                  </button>
                  to resend the link {' '}
                  {!sendAgain && (
                    <>
                      <span>in</span>
                      <span className="text-primary-red font-semibold  py-5 mx-1">
                        {minutes}:{seconds.toString().padStart(2, "0")}
                      </span>
                      <span>seconds</span>

                    </>
                  )}
                </p>
              </div>

            </AuthModal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckEmail;
